<template>
  <div class="groups bg-white h-full">
    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <Dropdown
            :options="typeDropdown"
            :selected="typeSelected"
            :title="'Activity Type'"
            v-on:updateOption="updateSelectedType"
            style="min-width: 10rem"
          ></Dropdown>
        </div>
      </template>



      <template v-slot:actions>
        <div v-if="1==4">
          <button
            type="button"
            class="action-button bg-purple-400 hover:opacity-75 mr-3"
            @click="addNew()"
          >
            <i class="fas fa-magic"></i>
            Create from tags
          </button>
        </div>

        <div>
          <button
            type="button"
            class="action-button hover:opacity-75 
             disabled:opacity-50 disabled:cursor-not-allowed"
            @click="addNew()"
                  :disabled="shouldShowUpgrade"
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Groups</p>
      </div>

      <div v-else>
        <div class="w-95p mx-auto grid grid-cols-4 gap-3 pb-10">
          <div
            v-for="item in filteredList"
            :key="item.identifier"
            @click="showGroupDisplay(item)"
            class="flex justify-center rounded-xl bg-gray-100 p-2 cursor-pointer hover:opacity-50"
          >
            <div class="flex w-full flex-col items-center p-2">
              <div
                class="h-32 w-full bg-opacity-25 flex items-center content-center justify-center rounded-lg inline-block"
                :class="parseBackgroundColor(item)"
              >
                <div class="text-center text-xl font-bold opacity-50">
                  {{ parseInitials(item.title) }}
                </div>
              </div>
              <h3 class="text-lg font-semibold pt-2 w-full text-center">
                {{ item.title }}
              </h3>
              <h4 class="uppercase opacity-50 text-orange-400">
                {{ getProgramType(item) }}
              </h4>
              <h3 class="opacity-50 py-2">{{ item.pupil_count }} Members</h3>
              <div class="flex mt-1" >
                <div  v-for="pupil in registersSlice(item)"
                :key="pupil.identifier"
                  class="w-12 h-12 bg-gray-200 -ml-3 rounded-full border border-white inline-block text-center text-xs pt-3 text-gray-600"
                >
                {{ parseInitials(pupil.name) }}
              </div>
                <div v-if="1==4 && item.pupil_count > 3"
                  class="w-12 h-12 bg-gray-700 -ml-3  rounded-full border border-white inline-block text-center text-base pt-2 font-semibold text-white"
                >
                {{ getAdditionalCount(item) }}+
              </div>
              </div>
            </div>
            <div class="opacity-50 flex flex-col p-2 pr-3">
              <i class="fas fa-ellipsis-v text-lg float-right opacity-50"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CrewService } from "@/services/crew.service";
import { eventTypes } from "@/assets/js/utils";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");

export default {
  name: "videos",
    mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.crews.length > 0;
    },
    typeDropdown() {
      let results = [{ id: 0, name: "All Program Types" }].concat(this.types);
      if (this.typeSelected.id === undefined) {
        this.typeSelected = results[0];
      }
      return results;
    },
    registersSlice() {
      return (crew) => {
        // targetDate is the argument passed to the handler
        return crew.registers != undefined ? crew.registers.slice(0, 3) : [];
      };
    },
    filteredList() {
      var vm = this;
      return this.crews.filter((item) => {
        let filtered = true;

        if (this.typeSelected.id > 0) {
          if (this.typeSelected.value === "education") {
            filtered = ["physical", "education"].includes(item.program_type);
          } else {
            filtered = item.program_type === this.typeSelected.value;
          }
        }

        if (filtered) {
          if (item.title != null) {
            filtered = item.title
              .toLowerCase()
              .includes(vm.search.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  data() {
    return {
      loading: true,
      errored: false,

      crews: [],

      search: "",

      types: eventTypes(),
      typeSelected: {},
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},
  methods: {
    fetchData() {
      this.loading = true;

      CrewService.getAll()
        .then((response) => (this.crews = response.data.data))
        .catch((err) => {
          console.log("crews " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    showGroupDisplay(crew) {
      this.$router.push({
        name: "CrewView",
        params: { crew: crew, newAddition: false },
      });
    },
    setSearchValue(value) {
      this.search = value;
    },
    updateSelectedType(type) {
      this.typeSelected = type;
    },
    parseInitials(string) {
      return string
        .split(" ")
        .map((n) => n[0])
        .join("")
        .substring(0, 3)
        .toUpperCase();
    },
    getMembersCount(crew) {
      return crew.registers != undefined ? crew.registers.length : 0;
    },
    getAdditionalCount(crew) {
      return crew.registers != undefined ? crew.registers.length - 3 : 0
    },
    getProgramType(crew) {
      let type = this.types.find((t) => t.value === crew.program_type);
      return type != undefined ? type.value : "Unknown";
    },
    parseBackgroundColor(crew) {
      let type = this.types.find((t) => t.value === crew.program_type);
      return type != undefined ? type.class : "bg-indigo-200";
    },
    addNew() {
      let crew = {};
      this.$router.push({
        name: "CrewView",
        params: { crew: crew, newAddition: true },
      });
    },
  },
  components: {
    Dropdown,
    FilterBar,
  },
};
</script>

<style>
</style>
